import { Device, ScreenSize } from 'glints-aries';
import { Colors } from 'glints-aries/es/@next';
import { space24, space32 } from 'glints-aries/es/@next/utilities/spacing';
import styled, { css } from 'styled-components';

export const responsiveContainerStyles = css`
  --responsive-container-inline-padding: 10px;

  padding: 0 var(--responsive-container-inline-padding);

  @media ${Device.mobileS} {
    --responsive-container-inline-padding: 10px;
  }
  @media (min-width: ${ScreenSize.mobileS}px) {
    --responsive-container-inline-padding: 10px;
  }
  @media (min-width: ${ScreenSize.mobileM}px) {
    --responsive-container-inline-padding: 20px;
  }
  @media (min-width: ${ScreenSize.mobileL}px) {
    --responsive-container-inline-padding: ${space24};
  }
  @media (min-width: ${ScreenSize.tablet}px) {
    --responsive-container-inline-padding: ${space32};
  }
  @media (min-width: ${ScreenSize.desktopS}px) {
    --responsive-container-inline-padding: ${space32};
  }
  @media (min-width: ${ScreenSize.desktopM}px) {
    --responsive-container-inline-padding: 30px;
  }
  @media (min-width: ${ScreenSize.desktopL}px) {
    --responsive-container-inline-padding: 20px;

    max-width: 1680px;
    width: 100%;
  }
`;

export const ResponsiveContainer = styled.div`
  ${responsiveContainerStyles}
`;

export const FullBleedSection = styled.div<{ $background: string }>`
  margin-inline: calc(-1 * var(--responsive-container-inline-padding, 0px));
  background: ${({ $background }) => $background};
  border-image: ${({ $background }) => $background} fill 0 / 0 / 0 100vw;
`;

export const StyledContainerV2 = styled(ResponsiveContainer)`
  position: relative;
  margin: 0 auto;
  font-family: Poppins, sans-serif;

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  &[data-loading='true'] {
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100vh - 70px - 24px);
  }

  &[data-full-width='true'] {
    &&& {
      width: 100%;
    }
  }
`;

export const FullBackground = styled.div`
  background-color: ${Colors.Neutral.B99};
  margin: 0;
  padding: 0;
  width: 100%;
  max-width: 100vw;
  padding-bottom: ${space24};
  min-height: calc(100vh - 70px);
`;
